import { Link } from "react-router-dom";
import { Lock } from "lucide-react";
import { InstagramLink } from "./InstagramLink";
import { NAV } from "./Header";
import { ACTIONS } from "./ActionButtons";

const linkCls = "text-lime hover:underline underline-offset-4 transition-colors";

export const Footer = () => (
  <footer className="relative overflow-hidden border-t border-[#1c2a12] bg-[#07080a] px-5 lg:px-12 pt-14 pb-8 mt-20 text-lime">
    <div className="relative max-w-4xl mx-auto text-center">
      <p className="font-gothic text-4xl sm:text-5xl mb-6 text-lime">Work with 00shot</p>
      <nav className="flex flex-wrap justify-center gap-x-8 gap-y-3 font-cond uppercase font-bold tracking-widest text-base">
        {ACTIONS.map(([to, label]) => (
          <Link key={to} to={to} className={linkCls} data-testid={`footer-action-${to.slice(1)}-link`}>{label}</Link>
        ))}
      </nav>
      <div className="mt-10 flex justify-center">
        <InstagramLink testid="footer-instagram-link" />
      </div>
      <nav className="mt-8 flex flex-wrap justify-center gap-x-6 gap-y-2 font-cond uppercase tracking-widest text-sm">
        {NAV.filter(([to]) => ["/shows", "/merch", "/gallery"].includes(to)).map(([to, label]) => (
          <Link key={to} to={to} className={linkCls} data-testid={`footer-nav-${to.slice(1)}`}>{label}</Link>
        ))}
      </nav>
    </div>
    <div className="relative mt-12 pt-6 border-t border-white/5 flex flex-col sm:flex-row gap-4 items-center justify-between text-xs text-lime">
      <span data-testid="footer-copyright">© {new Date().getFullYear()} 00shot. All rights reserved.</span>
      <Link to="/login?admin=1" data-testid="footer-admin-login-link" className={`inline-flex items-center gap-2 uppercase tracking-[0.2em] ${linkCls}`}>
        <Lock className="w-3.5 h-3.5" /> Admin login
      </Link>
    </div>
  </footer>
);
